import { Reveal, Overline } from "@/components/motion";

export const Model22p = () => (
  <section id="model" data-testid="model-section" className="py-24 sm:py-32 bg-[#0B1D16] text-[#FAF9F6] relative grain overflow-hidden">
    <div className="absolute top-1/3 -right-32 w-[420px] h-[420px] rounded-full bg-[#D97706]/10 blur-[120px] pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-16 items-center">
      <div>
        <Reveal><Overline dark>The donation model</Overline></Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-4 font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl leading-tight">
            One flat number. No "profits" ambiguity.
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-6 text-base sm:text-lg text-[#FAF9F6]/65 leading-relaxed max-w-lg">
            22p of every cup goes to the charity your workplace chooses. It is printed on the machine, printed on the receipt, and shown live on your location page. Simple enough to say out loud, honest enough to publish weekly.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <div className="mt-10 flex items-end gap-4">
            <p className="font-display font-extrabold text-[6rem] sm:text-[8rem] leading-none text-[#D97706]">22p</p>
            <p className="pb-4 text-sm font-mono-brand text-[#34D399] uppercase tracking-[0.18em]">per cup.<br />Every cup.</p>
          </div>
        </Reveal>
      </div>
      <Reveal delay={0.2}>
        <div data-testid="model-math-card" className="bg-[#13271F] border border-white/10 rounded-3xl p-8 sm:p-10">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#34D399]">The maths, in the open</p>
          <div className="mt-6 space-y-5">
            {[
              ["100 cups a week", "= £22 a week to charity"],
              ["A working year", "= £1,144 raised per site"],
              ["Ten workplaces", "= £11,440 a year of impact"],
            ].map(([a, b]) => (
              <div key={a} className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-4 border-b border-white/10 pb-5 last:border-0">
                <p className="font-mono-brand text-sm text-[#FAF9F6]/60 w-44 shrink-0">{a}</p>
                <p className="font-display font-bold text-xl text-[#FAF9F6]">{b}</p>
              </div>
            ))}
          </div>
          <p className="mt-6 text-xs text-[#FAF9F6]/45 leading-relaxed">
            Donations are tallied weekly from machine sales reports and paid to the chosen registered UK charity. Full breakdown in the FAQ.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
